import React from "react";
import { Route, Redirect } from "react-router-dom";
import {useSelector} from "react-redux";

function PrivateRouter({ component: Component, ...rest }) {
    const { user, authenticated } = useSelector(store => store.repository);

    return (
        <Route
            {...rest}
            render = { (props) =>
                user ? (
                    authenticated === true ? (
                            <Component {...props} {...rest} />
                        )
                        : <Redirect to="/login" />
                ): <Redirect to="/login" />
            }
        />
    );
}

export default PrivateRouter;